import React from "react";
import styles from "./TabMainTitle.module.scss";

export function TabMainTitle({ children }) {
  return <div className={styles.tab_main_title}>{children}</div>;
}
